import { loadModules } from 'esri-loader';
import mapConfig from '../config/mapConfig';

export default class GeometryHelper {
  static async getExtentOfAllFeatures(features) {
    const [Extent] = await loadModules(['esri/geometry/Extent']);

    if (!features || features.length == 0) {
      return null;
    }

    if (features[0].geometry.type == 'point') {
      if (features.length == 1) {
        let xmin = features[0].geometry.x - mapConfig.pointPaddingDistance;
        let xmax = features[0].geometry.x + mapConfig.pointPaddingDistance;
        let ymin = features[0].geometry.y - mapConfig.pointPaddingDistance;
        let ymax = features[0].geometry.y + mapConfig.pointPaddingDistance;
        return new Extent({
          xmin: xmin,
          ymin: ymin,
          xmax: xmax,
          ymax: ymax,
          spatialReference: features[0].geometry.spatialReference
        });
      } else {
        let xmin = Number.MAX_VALUE;
        let xmax = -Number.MAX_VALUE;
        let ymin = Number.MAX_VALUE;
        let ymax = -Number.MAX_VALUE;
        features.forEach((f) => {
          xmin = Math.min(xmin, f.geometry.x);
          xmax = Math.max(xmax, f.geometry.x);
          ymin = Math.min(ymin, f.geometry.y);
          ymax = Math.max(ymax, f.geometry.y);
        });
        const extent = new Extent({
          xmin: xmin,
          ymin: ymin,
          xmax: xmax,
          ymax: ymax,
          spatialReference: features[0].geometry.spatialReference
        });
        return extent;
      }
    } else {
      let xmin = Number.MAX_VALUE;
      let xmax = -Number.MAX_VALUE;
      let ymin = Number.MAX_VALUE;
      let ymax = -Number.MAX_VALUE;
      features.forEach((f) => {
        xmin = Math.min(xmin, f.geometry.extent.xmin);
        xmax = Math.max(xmax, f.geometry.extent.xmax);
        ymin = Math.min(ymin, f.geometry.extent.ymin);
        ymax = Math.max(ymax, f.geometry.extent.ymax);
      });
      const extent = new Extent({
        xmin: xmin,
        ymin: ymin,
        xmax: xmax,
        ymax: ymax,
        spatialReference: features[0].geometry.spatialReference
      });
      return extent;
    }
  }
}
